import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GrowerBenchmarkOnboardingChecklistItemFieldsFragment = { __typename?: 'GrowerBenchmarkOnboardingChecklistItem', itemKey: string, isComplete: boolean, completedByUserId?: string | null, completedAt?: Types.TDateISO | null };

export type GrowerBenchmarkFirmProfileFieldsFragment = { __typename?: 'GrowerBenchmarkFirmProfile', communityId: string, firmId: string, displayName: string, tags: Array<string>, ticker?: string | null, checklist: Array<{ __typename?: 'GrowerBenchmarkOnboardingChecklistItem', itemKey: string, isComplete: boolean, completedByUserId?: string | null, completedAt?: Types.TDateISO | null }> };

export type GrowerBenchmarkMemberDirectoryRowFieldsFragment = { __typename?: 'GrowerBenchmarkMemberDirectoryRow', firm: { __typename?: 'GrowerBenchmarkFirm', firmId: string, tenantId: string, label: string, isActive: boolean, classification: Array<{ __typename?: 'GrowerBenchmarkClassificationFacet', key: string, value: string }>, reportingUnits: Array<{ __typename?: 'GrowerBenchmarkReportingUnit', reportingUnitId: string, label: string, cadence: Types.GrowerBenchmarkReportingCadence }> }, profile: { __typename?: 'GrowerBenchmarkFirmProfile', communityId: string, firmId: string, displayName: string, tags: Array<string>, ticker?: string | null, checklist: Array<{ __typename?: 'GrowerBenchmarkOnboardingChecklistItem', itemKey: string, isComplete: boolean, completedByUserId?: string | null, completedAt?: Types.TDateISO | null }> } };

export type GrowerBenchmarkBillingSummaryRowFieldsFragment = { __typename?: 'GrowerBenchmarkBillingSummaryRow', firmId: string, displayName: string, source: Types.GrowerBenchmarkBillingSource, externalStatus?: string | null, externalPaidThrough?: Types.TDateISO | null, worksuiteSubscriptionStatus?: string | null, worksuiteCurrentPeriodEnd?: Types.TDateISO | null };

export type GrowerBenchmarkAccessLogEntryFieldsFragment = { __typename?: 'GrowerBenchmarkAccessLogEntry', entryId: string, occurredAt: Types.TDateISO, action: string, actorUserId: string, subjectUserId?: string | null, firmId?: string | null, detail: string };

export type GrowerBenchmarkFirmLookupFieldsFragment = { __typename?: 'GrowerBenchmarkFirmLookup', reason: string, openedAt: Types.TDateISO, firm: { __typename?: 'GrowerBenchmarkFirm', firmId: string, tenantId: string, label: string, isActive: boolean, classification: Array<{ __typename?: 'GrowerBenchmarkClassificationFacet', key: string, value: string }>, reportingUnits: Array<{ __typename?: 'GrowerBenchmarkReportingUnit', reportingUnitId: string, label: string, cadence: Types.GrowerBenchmarkReportingCadence }> }, profile: { __typename?: 'GrowerBenchmarkFirmProfile', communityId: string, firmId: string, displayName: string, tags: Array<string>, ticker?: string | null, checklist: Array<{ __typename?: 'GrowerBenchmarkOnboardingChecklistItem', itemKey: string, isComplete: boolean, completedByUserId?: string | null, completedAt?: Types.TDateISO | null }> }, submissions: Array<{ __typename?: 'GrowerBenchmarkSubmission', submissionId: string, communityId: string, firmId: string, reportingUnitId: string, periodId: string, version: number, status: Types.GrowerBenchmarkSubmissionStatus, submittedByUserId: string, submittedAt?: Types.TDateISO | null, approvalType?: Types.GrowerBenchmarkApprovalType | null, approvedByUserId?: string | null, approvedAt?: Types.TDateISO | null, supersededBySubmissionId?: string | null }> };

export type GetGrowerBenchmarkMemberDirectoryQueryVariables = Types.Exact<{
  communityId: Types.Scalars['String']['input'];
}>;


export type GetGrowerBenchmarkMemberDirectoryQuery = { __typename?: 'Query', growerBenchmarkMemberDirectory: Array<{ __typename?: 'GrowerBenchmarkMemberDirectoryRow', firm: { __typename?: 'GrowerBenchmarkFirm', firmId: string, tenantId: string, label: string, isActive: boolean, classification: Array<{ __typename?: 'GrowerBenchmarkClassificationFacet', key: string, value: string }>, reportingUnits: Array<{ __typename?: 'GrowerBenchmarkReportingUnit', reportingUnitId: string, label: string, cadence: Types.GrowerBenchmarkReportingCadence }> }, profile: { __typename?: 'GrowerBenchmarkFirmProfile', communityId: string, firmId: string, displayName: string, tags: Array<string>, ticker?: string | null, checklist: Array<{ __typename?: 'GrowerBenchmarkOnboardingChecklistItem', itemKey: string, isComplete: boolean, completedByUserId?: string | null, completedAt?: Types.TDateISO | null }> } }> };

export type GetGrowerBenchmarkBillingSummaryQueryVariables = Types.Exact<{
  communityId: Types.Scalars['String']['input'];
}>;


export type GetGrowerBenchmarkBillingSummaryQuery = { __typename?: 'Query', growerBenchmarkBillingSummary: Array<{ __typename?: 'GrowerBenchmarkBillingSummaryRow', firmId: string, displayName: string, source: Types.GrowerBenchmarkBillingSource, externalStatus?: string | null, externalPaidThrough?: Types.TDateISO | null, worksuiteSubscriptionStatus?: string | null, worksuiteCurrentPeriodEnd?: Types.TDateISO | null }> };

export type GetGrowerBenchmarkAccessLogQueryVariables = Types.Exact<{
  communityId: Types.Scalars['String']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetGrowerBenchmarkAccessLogQuery = { __typename?: 'Query', growerBenchmarkAccessLog: Array<{ __typename?: 'GrowerBenchmarkAccessLogEntry', entryId: string, occurredAt: Types.TDateISO, action: string, actorUserId: string, subjectUserId?: string | null, firmId?: string | null, detail: string }> };

export type GetGrowerBenchmarkAccessLogExportQueryVariables = Types.Exact<{
  communityId: Types.Scalars['String']['input'];
}>;


export type GetGrowerBenchmarkAccessLogExportQuery = { __typename?: 'Query', growerBenchmarkAccessLogExport?: { __typename?: 'GrowerBenchmarkAccessLogExport', fileName: string, csvBase64: string } | null };

export const GrowerBenchmarkOnboardingChecklistItemFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkOnboardingChecklistItemFields on GrowerBenchmarkOnboardingChecklistItem {
  itemKey
  isComplete
  completedByUserId
  completedAt
}
    `, {"fragmentName":"GrowerBenchmarkOnboardingChecklistItemFields"});
export const GrowerBenchmarkFirmProfileFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkFirmProfileFields on GrowerBenchmarkFirmProfile {
  communityId
  firmId
  displayName
  tags
  ticker
  checklist {
    ...GrowerBenchmarkOnboardingChecklistItemFields
  }
}
    fragment GrowerBenchmarkOnboardingChecklistItemFields on GrowerBenchmarkOnboardingChecklistItem {
  itemKey
  isComplete
  completedByUserId
  completedAt
}`, {"fragmentName":"GrowerBenchmarkFirmProfileFields"});
export const GrowerBenchmarkMemberDirectoryRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkMemberDirectoryRowFields on GrowerBenchmarkMemberDirectoryRow {
  firm {
    ...GrowerBenchmarkFirmFields
  }
  profile {
    ...GrowerBenchmarkFirmProfileFields
  }
}
    fragment GrowerBenchmarkOnboardingChecklistItemFields on GrowerBenchmarkOnboardingChecklistItem {
  itemKey
  isComplete
  completedByUserId
  completedAt
}
fragment GrowerBenchmarkFirmProfileFields on GrowerBenchmarkFirmProfile {
  communityId
  firmId
  displayName
  tags
  ticker
  checklist {
    ...GrowerBenchmarkOnboardingChecklistItemFields
  }
}
fragment GrowerBenchmarkFirmFields on GrowerBenchmarkFirm {
  firmId
  tenantId
  label
  isActive
  classification {
    ...GrowerBenchmarkClassificationFacetFields
  }
  reportingUnits {
    ...GrowerBenchmarkReportingUnitFields
  }
}
fragment GrowerBenchmarkClassificationFacetFields on GrowerBenchmarkClassificationFacet {
  key
  value
}
fragment GrowerBenchmarkReportingUnitFields on GrowerBenchmarkReportingUnit {
  reportingUnitId
  label
  cadence
}`, {"fragmentName":"GrowerBenchmarkMemberDirectoryRowFields"});
export const GrowerBenchmarkBillingSummaryRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkBillingSummaryRowFields on GrowerBenchmarkBillingSummaryRow {
  firmId
  displayName
  source
  externalStatus
  externalPaidThrough
  worksuiteSubscriptionStatus
  worksuiteCurrentPeriodEnd
}
    `, {"fragmentName":"GrowerBenchmarkBillingSummaryRowFields"});
export const GrowerBenchmarkAccessLogEntryFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkAccessLogEntryFields on GrowerBenchmarkAccessLogEntry {
  entryId
  occurredAt
  action
  actorUserId
  subjectUserId
  firmId
  detail
}
    `, {"fragmentName":"GrowerBenchmarkAccessLogEntryFields"});
export const GrowerBenchmarkFirmLookupFieldsFragmentDoc = new TypedDocumentString(`
    fragment GrowerBenchmarkFirmLookupFields on GrowerBenchmarkFirmLookup {
  firm {
    ...GrowerBenchmarkFirmFields
  }
  profile {
    ...GrowerBenchmarkFirmProfileFields
  }
  submissions {
    ...GrowerBenchmarkSubmissionFields
  }
  reason
  openedAt
}
    fragment GrowerBenchmarkOnboardingChecklistItemFields on GrowerBenchmarkOnboardingChecklistItem {
  itemKey
  isComplete
  completedByUserId
  completedAt
}
fragment GrowerBenchmarkFirmProfileFields on GrowerBenchmarkFirmProfile {
  communityId
  firmId
  displayName
  tags
  ticker
  checklist {
    ...GrowerBenchmarkOnboardingChecklistItemFields
  }
}
fragment GrowerBenchmarkFirmFields on GrowerBenchmarkFirm {
  firmId
  tenantId
  label
  isActive
  classification {
    ...GrowerBenchmarkClassificationFacetFields
  }
  reportingUnits {
    ...GrowerBenchmarkReportingUnitFields
  }
}
fragment GrowerBenchmarkClassificationFacetFields on GrowerBenchmarkClassificationFacet {
  key
  value
}
fragment GrowerBenchmarkReportingUnitFields on GrowerBenchmarkReportingUnit {
  reportingUnitId
  label
  cadence
}
fragment GrowerBenchmarkSubmissionFields on GrowerBenchmarkSubmission {
  submissionId
  communityId
  firmId
  reportingUnitId
  periodId
  version
  status
  submittedByUserId
  submittedAt
  approvalType
  approvedByUserId
  approvedAt
  supersededBySubmissionId
}`, {"fragmentName":"GrowerBenchmarkFirmLookupFields"});
export const GetGrowerBenchmarkMemberDirectoryDocument = new TypedDocumentString(`
    query GetGrowerBenchmarkMemberDirectory($communityId: String!) {
  growerBenchmarkMemberDirectory(communityId: $communityId) {
    ...GrowerBenchmarkMemberDirectoryRowFields
  }
}
    fragment GrowerBenchmarkOnboardingChecklistItemFields on GrowerBenchmarkOnboardingChecklistItem {
  itemKey
  isComplete
  completedByUserId
  completedAt
}
fragment GrowerBenchmarkFirmProfileFields on GrowerBenchmarkFirmProfile {
  communityId
  firmId
  displayName
  tags
  ticker
  checklist {
    ...GrowerBenchmarkOnboardingChecklistItemFields
  }
}
fragment GrowerBenchmarkMemberDirectoryRowFields on GrowerBenchmarkMemberDirectoryRow {
  firm {
    ...GrowerBenchmarkFirmFields
  }
  profile {
    ...GrowerBenchmarkFirmProfileFields
  }
}
fragment GrowerBenchmarkFirmFields on GrowerBenchmarkFirm {
  firmId
  tenantId
  label
  isActive
  classification {
    ...GrowerBenchmarkClassificationFacetFields
  }
  reportingUnits {
    ...GrowerBenchmarkReportingUnitFields
  }
}
fragment GrowerBenchmarkClassificationFacetFields on GrowerBenchmarkClassificationFacet {
  key
  value
}
fragment GrowerBenchmarkReportingUnitFields on GrowerBenchmarkReportingUnit {
  reportingUnitId
  label
  cadence
}`);
export const GetGrowerBenchmarkBillingSummaryDocument = new TypedDocumentString(`
    query GetGrowerBenchmarkBillingSummary($communityId: String!) {
  growerBenchmarkBillingSummary(communityId: $communityId) {
    ...GrowerBenchmarkBillingSummaryRowFields
  }
}
    fragment GrowerBenchmarkBillingSummaryRowFields on GrowerBenchmarkBillingSummaryRow {
  firmId
  displayName
  source
  externalStatus
  externalPaidThrough
  worksuiteSubscriptionStatus
  worksuiteCurrentPeriodEnd
}`);
export const GetGrowerBenchmarkAccessLogDocument = new TypedDocumentString(`
    query GetGrowerBenchmarkAccessLog($communityId: String!, $first: Int, $after: String) {
  growerBenchmarkAccessLog(
    communityId: $communityId
    first: $first
    after: $after
  ) {
    ...GrowerBenchmarkAccessLogEntryFields
  }
}
    fragment GrowerBenchmarkAccessLogEntryFields on GrowerBenchmarkAccessLogEntry {
  entryId
  occurredAt
  action
  actorUserId
  subjectUserId
  firmId
  detail
}`);
export const GetGrowerBenchmarkAccessLogExportDocument = new TypedDocumentString(`
    query GetGrowerBenchmarkAccessLogExport($communityId: String!) {
  growerBenchmarkAccessLogExport(communityId: $communityId) {
    fileName
    csvBase64
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetGrowerBenchmarkMemberDirectory: build.query<GetGrowerBenchmarkMemberDirectoryQuery, GetGrowerBenchmarkMemberDirectoryQueryVariables>({
      query: (variables) => ({ document: GetGrowerBenchmarkMemberDirectoryDocument, variables })
    }),
    GetGrowerBenchmarkBillingSummary: build.query<GetGrowerBenchmarkBillingSummaryQuery, GetGrowerBenchmarkBillingSummaryQueryVariables>({
      query: (variables) => ({ document: GetGrowerBenchmarkBillingSummaryDocument, variables })
    }),
    GetGrowerBenchmarkAccessLog: build.query<GetGrowerBenchmarkAccessLogQuery, GetGrowerBenchmarkAccessLogQueryVariables>({
      query: (variables) => ({ document: GetGrowerBenchmarkAccessLogDocument, variables })
    }),
    GetGrowerBenchmarkAccessLogExport: build.query<GetGrowerBenchmarkAccessLogExportQuery, GetGrowerBenchmarkAccessLogExportQueryVariables>({
      query: (variables) => ({ document: GetGrowerBenchmarkAccessLogExportDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetGrowerBenchmarkMemberDirectoryQuery, useLazyGetGrowerBenchmarkMemberDirectoryQuery, useGetGrowerBenchmarkBillingSummaryQuery, useLazyGetGrowerBenchmarkBillingSummaryQuery, useGetGrowerBenchmarkAccessLogQuery, useLazyGetGrowerBenchmarkAccessLogQuery, useGetGrowerBenchmarkAccessLogExportQuery, useLazyGetGrowerBenchmarkAccessLogExportQuery } = injectedRtkApi;
